import React from 'react';

const pukukoppiSun = () => {
  return (
    <div className="container">
        <div>
        <h4 className ='date-title'>Sunnuntai 18.05.2025</h4>
    <hr/>
      </div>
        <p>Pukukopit on joukkueilla käytössä koko turnauspäivän ajan. </p>
      
      <div className="table-container">
      
      <div className='sunnuntai-pukukopit'>
        <h3> U9 pukukoppijako</h3>
        <table className='ranking-table'>
          <thead>
            <tr>
              <th style ={{textAlign:'left'}}>Joukkue</th>
              <th style ={{textAlign:'left'}}>Koppi</th>
            </tr>
          </thead>
          <tbody>
          <tr>
            <td style ={{textAlign:'left'}}> 
              <img src='https://upload.wikimedia.org/wikipedia/commons/b/b1/Helsingin_J%C3%A4%C3%A4kiekkoklubi_logo.png' 
              alt='HJK logo' 
              className='pukukoppi-logo' />
                HJK </td>
                <td style ={{textAlign:'left'}}> Ulkokoppi 1</td>
            </tr>
            <tr>
            <td style ={{textAlign:'left'}}> 
              <img src='https://files.eliteprospects.com/layout/logos/f667f640-87d9-4879-b248-dde1387fac00_large.png' 
              alt='Wolf logo' 
              className='pukukoppi-logo' />
                Sipoon Wolf</td>
                <td style ={{textAlign:'left'}}>  Ulkokoppi 3</td>
            </tr>
            <tr>
            <td style ={{textAlign:'left'}}> 
            <img src='https://upload.wikimedia.org/wikipedia/fi/e/e3/Viikingit_HC_logo.png' 
              alt='Viikingit logo' 
              className='pukukoppi-logo' />
                Viikingit </td>
                <td style ={{textAlign:'left'}}> Koppi 2 </td>
            </tr>
            <tr>
            <td style ={{textAlign:'left'}}> 
            <img src='https://static.jopox.fi/hunters/logos/logo-600.png' 
              alt='Hunterlogo' 
              className='pukukoppi-logo' />
              Hunters </td>
              <td style ={{textAlign:'left'}}> Koppi 3</td>
            </tr>
           
          </tbody>
        </table>
        </div>
      </div>
    
      <div className='sunnuntai-pukukopit'>
        <h3>U8 pukukoppijako</h3>
        <table className='ranking-table'>
          <thead>
            <tr>
              <th style ={{textAlign:'left'}}>Joukkue</th>
              <th style ={{textAlign:'left'}}>Koppi</th>
            </tr>
          </thead>
          <tbody>
            <tr>
            <td style ={{textAlign:'left'}}> 
            <img src='https://files.eliteprospects.com/layout/logos/f667f640-87d9-4879-b248-dde1387fac00_large.png' 
              alt='Wolf logo' 
              className='pukukoppi-logo' />
                Sipoon Wolf </td>
                <td style ={{textAlign:'left'}}> Ulkokoppi 2</td>
            </tr>
            <tr>
            <td style ={{textAlign:'left'}}> 
            <img src='https://upload.wikimedia.org/wikipedia/fi/3/3f/Karhu-Kissat.png?20161030101639' 
              alt='Karhu Kissat logo' 
              className='pukukoppi-logo' />
                Karhu Kissat </td>
                <td style ={{textAlign:'left'}}> Koppi 1</td>
            </tr>
            <tr>
            <td style ={{textAlign:'left'}}> 
            <img src='https://static.jopox.fi/hunters/logos/logo-600.png' 
              alt='Hunterlogo' 
              className='pukukoppi-logo' />
                Hunters </td>
                <td style ={{textAlign:'left'}}> Koppi 3 & Iso Valmennus</td>
            </tr>   
            <tr>
            <td style ={{textAlign:'left'}}> 
            <img src='https://upload.wikimedia.org/wikipedia/en/thumb/2/23/Kiekko-Espoo_logo_2021.png/250px-Kiekko-Espoo_logo_2021.png' 
              alt='Kiekko Espoo logo' 
              className='pukukoppi-logo' />
                Kiekko Espoo</td>
                <td style ={{textAlign:'left'}}> Koppi 4 </td>
            </tr>
           
           
            
          </tbody>
        </table>
        </div>
      </div>
  );
};

export default pukukoppiSun;
